import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./NoPage.scss";
import MyContext from "../Context/MyContext";

const NoPage = () => {
  const navigate = useNavigate();
  const { handleNavClick } = useContext(MyContext);

  

  return (
    <div className="no-page-content">
      <h1 className="no-page-title">404</h1>
      <p className="no-page-message">Oops! The page you're looking for doesn't exist.</p>
      <button className="no-page-button" onClick={() => handleNavClick("/")}>
        Go Back to Home
      </button>
    </div>
  );
};

export default NoPage;
